export default __webpack_public_path__ + "static/image3-223c6cd480db883af78565c070eab166.png";